import React, { useEffect, useState, useRef } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
// 🚀 1. Correção do caminho de importação (apenas um ../)
import { db } from "../config/firebase"; 
import { Bell, X } from "lucide-react";

const NotificationRadar = () => {
  const [toasts, setToasts] = useState([]);
  const isInitialLoad = useRef(true);

  // 🎵 Sintetizador de Áudio Nativo (Sem necessidade de arquivos mp3)
  const playSound = () => {
    try {
      // 🚀 2. Correção da tipagem do window para o Linter do VS Code
      const AudioContext = window.AudioContext || window['webkitAudioContext'];
      if (!AudioContext) return;
      
      const audioCtx = new AudioContext();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      // Configuração para um som suave de notificação (tipo sino/ding)
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(880, audioCtx.currentTime); // Frequência aguda (Nota A5)
      oscillator.frequency.exponentialRampToValueAtTime(440, audioCtx.currentTime + 0.1);
      
      gainNode.gain.setValueAtTime(0.3, audioCtx.currentTime); // Volume inicial
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.5); // Fade out

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.5);
    } catch (error) {
      console.warn("Navegador bloqueou o áudio automático. O usuário precisa interagir com a tela primeiro.", error);
    }
  };

  useEffect(() => {
    // 🔍 O Radar: Escutando qualquer solicitação que entre como "Em Analise"
    const q = query(
      collection(db, "requests"),
      where("status", "==", "Em Analise")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      // Ignora o carregamento inicial para não floodar a tela com as que já existiam
      if (isInitialLoad.current) {
        isInitialLoad.current = false;
        return;
      }

      // Procura apenas pelos documentos que foram ADICIONADOS ou MODIFICADOS para esse status agora
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added" || change.type === "modified") {
          const data = change.doc.data();

          playSound();

          const newToast = {
            id: change.doc.id + Date.now(), // Garante ID único para a animação
            company: data.companyName || "Imobiliária Parceira",
            protocolo: data.protocolo || "Novo Protocolo",
          };

          setToasts((prev) => [...prev, newToast]);

          // Some da tela automaticamente após 6 segundos
          setTimeout(() => {
            setToasts((current) => current.filter((t) => t.id !== newToast.id));
          }, 6000);
        }
      });
    });

    return () => unsubscribe();
  }, []);

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-3 pointer-events-none">
      {toasts.map((toast) => (
        <div 
          key={toast.id} 
          // 🚀 3. Correção do conflito de bordas do Tailwind
          className="bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border border-l-4 border-l-brand-primary shadow-2xl rounded-xl p-4 w-80 sm:w-96 flex items-start gap-4 pointer-events-auto transition-all transform translate-y-0 opacity-100"
        >
          <div className="bg-brand-primary/10 text-brand-primary p-2.5 rounded-full shrink-0 mt-0.5">
            <Bell className="w-5 h-5 animate-bounce" />
          </div>
          
          <div className="flex-1">
            <h4 className="text-sm font-black text-light-text-primary dark:text-dark-text-primary uppercase tracking-wide">
              Nova Ficha Recebida!
            </h4>
            <p className="text-xs text-light-text-secondary dark:text-dark-text-secondary mt-1.5 leading-relaxed">
              A imobiliária <strong className="text-brand-primary">{toast.company}</strong> enviou a solicitação <span className="font-mono bg-light-bg dark:bg-dark-bg px-1.5 py-0.5 rounded border border-light-border dark:border-dark-border">{toast.protocolo}</span>.
            </p>
          </div>

          <button 
            onClick={() => removeToast(toast.id)}
            className="text-light-text-secondary hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 p-1 rounded-lg transition-colors shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationRadar;